export default {
  BusinessReportSaleShop: {
    orderTime: '下单时间',
    storeType: '店铺类型',
    organization: '所属公司',
    storeName: '店铺名称',
    storeCode: '店铺编码',
    storeTypeCode: '店铺类型',
    orderCount: '订单数',
    orderAmount: '销售金额',
    reverseOrderCount: '退款单数',
    reverseOrderAmount: '退款金额',
  }
};
